import { render, staticRenderFns } from "./DownloadKeuringen.vue?vue&type=template&id=3cdca80e"
import script from "./DownloadKeuringen.vue?vue&type=script&lang=js"
export * from "./DownloadKeuringen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports